// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.user-edit-container ::ng-deep .mat-mdc-tab-body-wrapper {
  height: 100%;
}`, "",{"version":3,"sources":["webpack://./src/app/modules/user/components/user-edit/user-edit.component.scss"],"names":[],"mappings":"AAEE;EACC,YAAA;AADH","sourcesContent":[".user-edit-container {\n\t::ng-deep {\n\t\t.mat-mdc-tab-body-wrapper {\n\t\t\theight: 100%;\n\t\t}\n\t}\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
